import React, { useCallback, useContext, useEffect, useReducer } from 'react'
import { Button, Col, Form, message, Row, Select, Typography, Divider } from 'antd'
import './Report.css'
import { simpleReducer } from '../../../helper'
import { AppConfig } from '../../../AppConfig'
import ReportList from '../../../components/Admin/Reports/ReportList'
import { useGetReportsQueue, useMutateDispatchReportToQueue } from '../../../api/react-query/reports'
import { ConfigContext } from '../../../context/configContext'
import FilterTitle from './FilterTitle'
import { usePartnerRoles } from '../../../hooks'

const { Title } = Typography
const { Option } = Select

const selectSearchFilter = (input, option) => {
  return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

const initialState = {
  selectedCities: [],
  groups: [],
  role: null
}

export default function SignedOffersReport () {
  const { isContentCoordinator, isResearcherCoordinator, isOperatorCoordinator, isMentorCoordinator } = useContext(ConfigContext)
  const [form] = Form.useForm()
  const [state, setState] = useReducer(simpleReducer, initialState)

  const {
    isError: isErrorReportsQueue,
    data: dataReportsQueue,
    isLoading: isLoadingReportsQueue,
    refetch: refetchReportsQueue
  } = useGetReportsQueue(AppConfig.report.types.signedOffers)

  const {
    mutate: addReportToQueue,
    isError: isErrorAddReportToQueue,
    data: dataAddReportToQueue,
    isLoading: isLoadingAddReportToQueue
  } = useMutateDispatchReportToQueue()

  useEffect(() => {
    if (isErrorAddReportToQueue || dataAddReportToQueue?.errorMessage) {
      message.error(dataAddReportToQueue?.errorMessage || 'Не удалось поставить отчет в очередь')
    }
  }, [isErrorAddReportToQueue, dataAddReportToQueue])

  useEffect(() => {
    if (isErrorReportsQueue || dataReportsQueue?.errorMessage) {
      message.error(dataReportsQueue?.errorMessage || 'Не удалось получить отчеты')
    }
  }, [isErrorReportsQueue, dataReportsQueue])

  const handleChangeRole = useCallback(
    (value, items) => {
      console.log(items)
      setState({
        role: items.key
      })
    },
    []
  )

  const { data: roles } = usePartnerRoles()
  const isExtendsCoordinator = isContentCoordinator || isResearcherCoordinator || isOperatorCoordinator || isMentorCoordinator
  useEffect(() => {
    if (isContentCoordinator) {
      setState({ role: AppConfig.partnerRoles.szContent })
    }
    if (isResearcherCoordinator) {
      setState({ role: AppConfig.partnerRoles.researcher })
    }
    if (isOperatorCoordinator) {
      setState({ role: AppConfig.partnerRoles.szOperator })
    }
    if (isMentorCoordinator) {
      setState({ role: AppConfig.partnerRoles.szMentor })
    }
  }, [isContentCoordinator, isResearcherCoordinator, isOperatorCoordinator, isMentorCoordinator, roles])

  const handleAddReportToQueue = () => {
    addReportToQueue({
      type: AppConfig.report.types.signedOffers,
      data: {
        role: state.role
      }
    })
  }

  return (
    <>
      <Title level={3} className='title-management'>Отчет по подписанным офертам</Title>
      <Form
        form={form}
      >
        {!isExtendsCoordinator && (
          <FilterTitle title='Роль'>
            <Form.Item name='cities'>
              <Select
                onChange={handleChangeRole}
                size='middle'
                placeholder='Выберете роль'
                showSearch
                optionFilterProp='children'
                filterOption={selectSearchFilter}
                allowClear
                value={state.role}
              >
                {roles?.map(city => (
                  <Option key={city.id} value={city.name}>
                    {city.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </FilterTitle>
        )}
        <Row>
          <Col className='mr-3'>
            <Button
              loading={isLoadingAddReportToQueue}
              type='primary'
              htmlType='button'
              onClick={() => handleAddReportToQueue()}
              disabled={!state.role}
            >
              Запросить отчет
            </Button>
          </Col>
        </Row>
      </Form>
      {
        dataReportsQueue?.items &&
          <>
            <Divider />
            <Row className='mt-3' align='middle' gutter={15} style={{ marginBottom: '1em' }}>
              <Col>
                <Title level={5} style={{ marginBottom: 0 }}>Отчеты</Title>
              </Col>
              <Col>
                <Button onClick={() => refetchReportsQueue()}>Обновить</Button>
              </Col>
            </Row>
            <ReportList
              isLoadingReports={isLoadingReportsQueue}
              dataReports={dataReportsQueue?.items}
            />
          </>
      }
    </>
  )
}
